/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { BabylonRelayerSummaryInfo } from './BabylonRelayerSummaryInfo';

export type BabylonRelayerDetailInfo = {
    RLYR: BabylonRelayerSummaryInfo;
    STAT: BabylonRelayerDetailInfo.STAT;
    TCHCNT: string;
    OPCHCNT: string;
    TTRXCNT: string;
    AG: string;
    UT: number;
};

export namespace BabylonRelayerDetailInfo {

    export enum STAT {
        OPENED = 'OPENED',
        CLOSED = 'CLOSED',
    }


}

